import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Box, Card, Tab, Tabs } from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import React, { useEffect, useState } from "react";

import TabPanel from "../../helpers/TabPanel";
import ViewAllReportsPage from "./ViewAllReportsPage"; // Task Report
import ViewAllProjectsReportsPage from "./ViewAllProjectsReportsPage"; // Project Report
import ViewProjectReports from "./ViewProjectReports";
import ViewProgramReports from "./ViewProgramReports"; 
import ViewTaskReport from "./ViewTaskReport";

const ProjectGeneralReport = ({
    location,
    SetSelectedMenu,
    selectedMenu,
    resources,
    GetAllResources,
}) => {
    const [tabValue, setTabValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "view-report",
            title: "general Report",
        });
        GetAllResources();
    }, []);

    return (
        <Card>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab label={"Task Report"} {...a11yProps(0)} />
                    <Tab label={"Project Report"} {...a11yProps(1)} />
                    <Tab label={"Program Report"} {...a11yProps(2)} />

                </Tabs>

                <TabPanel index={0} value={tabValue} p={0}>
                    <ViewTaskReport
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
                <TabPanel index={1} value={tabValue} p={0}>
                    <ViewProjectReports
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
                <TabPanel index={2} value={tabValue} p={0}>
                    <ViewProgramReports
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>

            </Box>
        </Card>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectGeneralReport);